import React, { Component } from 'react'
import { useNavigate } from 'react-router-dom'

// Load components synchronously
import FieldRow from 'components/FieldRow/FieldRow'
import LinkButton from 'components/SmallButtonPrimary/LinkButton'

// assets
import { ExternalLinkAlt } from '@styled-icons/fa-solid'

// utils
import th from 'utils/themeHelper'

// styles
import {
  CommitmentText,
  CloseIcon,
  CloseModalShortWrapper,
  ExternalLink,
  ModalContainer,
  ModalWrapper,
  ModalHeader,
  ScreenWrapper
} from './styles'

function withNavigation(Component) {
  return function NavigationWrappedComponent(props) {
    const navigate = useNavigate()
    return <Component {...props} navigate={navigate} />
  }
}

class PendingModal extends Component {
  constructor(props) {
    super(props)
    this.escFunction = this.escFunction.bind(this)
    this.manageExternalRedirect = this.manageExternalRedirect.bind(this)
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.hideModal()
    }
  }

  manageExternalRedirect() {
    const urlSearch = window.location.search
      .replace('pending=true', 'hasRedirected=true')
      .replace(/\&$/, '')
    const path = window.location.pathname + urlSearch
    this.props.navigate(path, { replace: true })
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }

  render() {
    const { hideModal, extraInfoModalOpts } = this.props
    const { externalDonationUrl = '' } = extraInfoModalOpts

    if (!externalDonationUrl) {
      return (
        <ScreenWrapper>
          <ModalWrapper>
            <ModalContainer>
              <CloseIcon dark size={30} onClick={hideModal} />

              <ModalHeader>Something went wrong</ModalHeader>

              <CommitmentText>
                Please reload this page and retry your donation attempt.
              </CommitmentText>

              <CloseModalShortWrapper>
                <LinkButton onClick={hideModal}>Dismiss</LinkButton>
              </CloseModalShortWrapper>
            </ModalContainer>
          </ModalWrapper>
        </ScreenWrapper>
      )
    }

    const isPayfastProductionUrl = externalDonationUrl.match(/^https\:\/\/browniepoints\.africa/)
    const isPayfastStagingUrl = externalDonationUrl.match(
      /^https\:\/\/develop\.browniepoints\.africa/
    )
    const isPayfastUrl = isPayfastProductionUrl || isPayfastStagingUrl
    if (isPayfastUrl) {
      return (
        <ScreenWrapper>
          <ModalWrapper>
            <ModalContainer>
              <CloseIcon dark size={30} onClick={hideModal} />

              <ModalHeader>Redirecting to complete payment.</ModalHeader>

              <CommitmentText>Please wait a few seconds.</CommitmentText>
            </ModalContainer>
          </ModalWrapper>
        </ScreenWrapper>
      )
    }

    const isOzowUrl = externalDonationUrl.match(/^https?\:\/\/pay\.ozow\.com/)
    if (isOzowUrl) {
      return (
        <ScreenWrapper>
          <ModalWrapper>
            <ModalContainer>
              <CloseIcon dark size={30} onClick={hideModal} />

              <ModalHeader>Redirecting to complete payment.</ModalHeader>

              <CommitmentText>
                You will be redirected to an external payment site now.
              </CommitmentText>
            </ModalContainer>
          </ModalWrapper>
        </ScreenWrapper>
      )
    }

    return (
      <ScreenWrapper>
        <ModalWrapper>
          <ModalContainer>
            <CloseIcon dark size={30} onClick={hideModal} />

            <ModalHeader>Complete your donation</ModalHeader>

            <CommitmentText>
              When you click the button below, you will be redirected to:{' '}
              <strong>{externalDonationUrl}</strong>
            </CommitmentText>

            <CommitmentText>
              Please make sure you trust the above website before completing any payments. Brownie
              Points has no affiliation with this website.
            </CommitmentText>

            <FieldRow>
              <ExternalLink
                href={externalDonationUrl}
                target="_blank"
                onClick={this.manageExternalRedirect}
              >
                <LinkButton
                  overrideBg={th('primary.base')}
                  overrideColor="white"
                  icon={ExternalLinkAlt}
                  iconSize="15px"
                  iconMarginTop="-3px"
                >
                  Visit External Website
                </LinkButton>
              </ExternalLink>
            </FieldRow>
          </ModalContainer>
        </ModalWrapper>
      </ScreenWrapper>
    )
  }
}

export default withNavigation(PendingModal)
